module.exports = __webpack_public_path__ + "media/teams/reallife-a5115ccb.png";